import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeMultipleDocuments extends Shape {
    width = 200;
    height = 140;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width / 2 - 2 * horizontalPadding;
        const allowedHeight = (height * 5) / 6 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 9, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 10;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();

        canv.ctx.moveTo(x, y + h * 0.7);
        canv.ctx.arcTo(x, y, x + r, y, r);
        canv.ctx.arcTo(x + w * 0.93 - r, y, x + w * 0.93 - r, y + h * 0.2, r);
        canv.ctx.arcTo(x + w, y + h * 0.1, x + w, y + h, r);
        canv.ctx.lineTo(x + w, y + h);
        canv.ctx.bezierCurveTo(
            x + w * 0.67,
            y + h * 0.55,
            x + w * 0.4,
            y + h * 1.3,
            x + w * 0.08,
            y + h * 0.9,
        );
        canv.ctx.lineTo(x + w * 0.08, y + h * 0.8);
        canv.ctx.lineTo(x, y + h * 0.7);

        canv.ctx.moveTo(x + w * 0.08, y + h * 0.8);
        canv.ctx.arcTo(x + w * 0.08, y + h * 0.1, x + w * 0.08 + r, y + h * 0.1, r);
        canv.ctx.lineTo(x + w * 0.93 - r, y + h * 0.1);
        canv.ctx.moveTo(x + w * 0.93 - r, y + h * 0.1);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round" d="M1 15.23V6.46C1 5.1 2.1 4 3.44 4h17.94M4.4 7.37H23V20s-2.7-2.97-5.1-2.97c-3.46 0-4.93 2.97-8.36 2.97-2.31 0-5.14-2.97-5.14-2.97V7.37Z"/>
            </svg>
        `;
    }
}
